






































import {
    Component, Mixins, Model, Prop, Watch,
} from 'vue-property-decorator';
import { filter, map, findIndex } from 'lodash';
import InsertPhotoDialogPhotosItem from '@/components/global/InsertPhotoDialog/InsertPhotoDialogPhotosItem.vue';
import PhotoIntegrationMixin from '@/mixins/vue/PhotoIntegrationMixin';
import { ImageInfo } from '@luxtag/papybase';
import papybaseConfig from '@/plugins/papybase/papybaseConfig';
import { CSVFile, MUTATE_CSV_FILE, DELETE_CSV_FILE } from '@/store/modules/csv';
import ZebraList from '@/components/global/zebraList/ZebraList.vue';
import ZebraListItem from '@/components/global/zebraList/ZebraListItem.vue';
import SimpleDialog from '@/components/global/SimpleDialog.vue';

@Component({
    components: {
        ZebraList,
        ZebraListItem,
        SimpleDialog,
    },
})
export default class InsertCsvDialogOpen extends Mixins(PhotoIntegrationMixin) {
    @Prop() readonly dialogStatus!: boolean;

    public menuItems = ['Rename', 'Delete'];

    public activeIndex = -1;
    public renameActiveIndex = -1;

    public onItemDeleteClick(csvFile: CSVFile) {
        this.$store.commit(DELETE_CSV_FILE, csvFile.name);
    }

    public open(csvFile: CSVFile) {
        this.$emit('open', csvFile);
    }

    public onClick(i: number) {
        this.activeIndex = i;
    }

    public onRename(csvFile: CSVFile, newName: string) {
        // if old name same as new name then cancel rename
        if (csvFile.name === newName) {
            return;
        }

        // if another file with the same name exist then cancel
        const foundDuplicateCSVFile = this.$store.getters.getCSV(newName.trim());
        if (foundDuplicateCSVFile) {
            this.$emit('updateInfoDialogProperties', {
                title: 'Duplicate Name Exist',
                message: `The name "${newName}" is already taken. Please choose a different name.`,
            });
            return;
        }

        const theCSVFile = csvFile;
        theCSVFile.name = newName;

        this.$store.commit(MUTATE_CSV_FILE, theCSVFile);
    }

    get csvFiles(): CSVFile[] {
        return this.$store.getters.getCSVs;
    }

    @Watch('activeIndex')
    private onActiveListChange(val: any) {
        this.renameActiveIndex = -1;
        if (val !== -1) {
            this.$emit('activeItem', this.csvFiles[val]);
        } else {
            this.$emit('activeItem', null);
        }
    }
}
